module.exports = __webpack_public_path__ + "media/images/sp/lp/bg-ribbon-left-63ffc603c4b85718f9a6c8cd0d3e1ee6.svg";